import React from "react";
import Link from "next/link";
import Image from "next/image";


interface BlockProps {
  image: string;
  title: string;
  link: string;
}

interface OurWebsitesProps {
  blocks: BlockProps[];
}

const OurWebsites: React.FC<OurWebsitesProps> = ({ blocks }) => {
  return (
    <div id="web-development" className="flex flex-col gap-6">
      <div>
        <div className="text-center">
          <h3>Our Projects</h3>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {blocks.map((block, index) => (
          <Link
            key={index}
            href={block.link}
            className="group relative w-full h-[300px] flex justify-center items-center overflow-hidden rounded-[25px] shadow-lg bg-white transition-all duration-300 hover:bg-white hover:bg-gradient-to-b hover:from-white hover:to-[#F1F7FC]"
          >
            <div className="w-[450px] h-[300px] flex justify-center items-center">
              <div className="relative w-[50%] h-[50%] flex justify-center items-center"> 
                <img
                  src={block.image}
                  alt={block.title}
                  className="object-contain"
                />
              </div>
            </div>

            <div className="absolute inset-0 flex flex-col justify-center items-center gap-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 bg-white bg-opacity-100 rounded-lg group-hover:bg-opacity-90 hover:bg-gradient-to-b hover:to-[#F1F7FC]">
              <h2 className="text-[1.5rem] leading-none text-center text-black font-semibold">
                {block.title}
              </h2>
              <p className="text-black flex items-center gap-1 underline text-sm">
                Explore More Details
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default OurWebsites;